//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Btn from './Btn.vue';
import IconArrow from './IconArrow.vue';

export default {
	name: 'TagNav',

	components: { Btn: Btn, IconArrow: IconArrow },

	props: {
		total: {
			type: Number,
			required: true
		},

		perPage: {
			type: Number,
			required: true
		}
	},

	computed: {
		basePath: function basePath() {
			var str = this.$route.path + '?';

			if (this.tag) str = str + '&tag=' + this.tag;
			if (this.filter) str = str + '&filter=' + this.filter;
			if (this.req) str = str + '&req=' + this.req;

			return str.replace('&', '');
		},
		tag: function tag() {
			return this.$route.query.tag;
		},
		filter: function filter() {
			return this.$route.query.filter;
		},
		req: function req() {
			return this.$route.query.req;
		},
		current: function current() {
			return this.$route.query.page || 1;
		},
		pageCount: function pageCount() {
			return Math.ceil(this.total / this.perPage);
		},
		pageArr: function pageArr() {
			var arr = [];

			for (var i = 0; i < this.pageCount; i++) {
				arr.push(i + 1);
			}

			return arr;
		},
		items: function items() {

			var arr = [],
			    current = parseInt(this.current, 10);

			if (current === 1) {
				arr = this.pageArr.slice(0, 3);
			} else if (current === this.pageCount) {
				arr = this.pageArr.slice(-3);
			} else {
				arr = this.pageArr.slice(current - 2, current + 1);
			}

			return arr;
		},
		prevPage: function prevPage() {
			return this.current - 1 || 1;
		},
		nextPage: function nextPage() {
			var page = parseInt(this.current, 10);
			return page == this.pageCount ? this.pageCount : page + 1;
		}
	},

	methods: {
		onClick: function onClick() {
			document.documentElement.scrollTop = 0;
			document.body.scrollTop = 0;
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Pagination.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Pagination.vue
// module chunks = 0